<template>
  <v-dialog v-model="show" width="80vw" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="third">
        <span class="d-flex justify-center flex-grow-1 font-weight-bold text-h6 white--text">{{ document.fileName || 'Aperçu du document' }}</span>
        <v-icon v-if="document.url && isImage" size="28" color="white" class="mr-4" @click="downloadDocument">mdi-file-download-outline</v-icon>
        <v-icon size="28" color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-0">
        <div v-if="document.url && isImage" class="d-flex justify-center pa-4">
          <img :src="document.url" :alt="document.fileName" class="file-preview-image" />
        </div>
        <iframe
          v-else-if="document.url && canDisplayPdf"
          :src="document.url"
          class="file-preview-iframe"
          frameborder="0"
        />
        <div v-else-if="document.url && !canDisplayPdf" class="d-flex flex-column align-center justify-center pa-8">
          <p class="grey--text text-body-1 text-center mb-4">Votre navigateur ne peut pas afficher les PDF.</p>
          <v-btn color="third" class="white--text" @click="downloadDocument">
            <v-icon left>mdi-file-download-outline</v-icon>
            Télécharger le document
          </v-btn>
        </div>
        <div v-else class="d-flex align-center justify-center pa-8 grey--text">
          Aucun document à afficher
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed } from '@vue/composition-api';
import { downloadS3File } from '@/helpers/request';
import { sendNotification, blobDownload } from '@/helpers/utils';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    document: {
      type: Object,
      default: () => ({ url: null, fileName: null })
    }
  },
  setup(props, { emit }) {
    const canDisplayPdf = typeof navigator !== 'undefined' && navigator.pdfViewerEnabled === true;

    const isImage = computed(() => {
      const fileName = props.document?.fileName?.toLowerCase() || '';
      return /\.(jpg|jpeg|png)$/.test(fileName);
    });

    const closeDialog = () => {
      emit('closeModal');
    };

    const downloadDocument = async () => {
      try {
        const blob = await downloadS3File(props.document.url, props.document.fileName);
        blobDownload(blob, props.document.fileName);
        sendNotification('success', 'Document téléchargé avec succès');
      } catch (error) {
        sendNotification('error', error?.message || 'Erreur lors du téléchargement du document');
      }
    };

    return { canDisplayPdf, isImage, closeDialog, downloadDocument };
  }
};
</script>

<style scoped>
.file-preview-iframe {
  width: 100%;
  height: 75vh;
  border: none;
}

.file-preview-image {
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
}
</style>
